import { useEffect } from 'react';
import { isEmbedded } from '@/Utils/superops/embedDetection';
import { SuperOpsMessageService } from '../services/SuperOpsMessageService';
import { SUPEROPS_CONFIG } from '../config/SuperOpsConfig';

/**
 * Custom hook for handling embedded mode functionality
 * Initializes message service and applies CSS classes when in embedded mode
 */
export const useEmbeddedMode = () => {
  const isEmbeddedMode = isEmbedded();

  useEffect(() => {
    if (isEmbeddedMode) {
      // Initialize SuperOps message service
      SuperOpsMessageService.getInstance().initialize();
      
      // Add embedded CSS class to body
      document.body.classList.add(SUPEROPS_CONFIG.CSS_CLASSES.EMBEDDED_MODE);
      
      return () => {
        document.body.classList.remove(SUPEROPS_CONFIG.CSS_CLASSES.EMBEDDED_MODE);
      };
    }
    
    return undefined;
  }, [isEmbeddedMode]);

  return { isEmbeddedMode };
};